"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValue = getValue;

function getValue(props) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (typeof props.value !== 'undefined' && props.value !== null) {
    return props.value;
  }

  if (typeof props.defaultValue !== 'undefined' && props.defaultValue !== null) {
    return props.defaultValue;
  }

  return defaultValue;
}